export const emailVerificationKeys = {
  token: () => ['CHECK_TOKEN'] as const,
  send: () => ['SEND_EMAIL_VERIFICATION'] as const,
};
